import React, { useReducer, useEffect, useContext} from "react";
import procedimientoContext from "./procedimientoContext";
import { getAllProcedimiento, addProcedimiento, updateProcedimiento, deleteProcedimiento, getProcByID } from "../../api/procedimiento.js";
import procedimientoReducer from "./procedimientoReducer";
//Types
import { 
    ACTUALIZAR_LIST_PROCEDIMIENTO,
  } from "./procedimientoActions.js";
import authContext from "../authentication/authContex.js";
import { SocketContext } from "../socket/socket.js";

const ProcedimientoState = props =>{

    const initialState = {
        procedimientoList: null
    };

    const [state, dispatch] = useReducer(procedimientoReducer, initialState);
    const server = useContext(SocketContext);

    const auContext = useContext(authContext);
    const {verificarTenant, usuario} = auContext;

    const actualizarProcedimientoList = async () => {
        try{
            const resp = await getAllProcedimiento();
            const procedimiento = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_PROCEDIMIENTO,
                payload: procedimiento
            });
            return procedimiento;
        }catch(err){
            console.log(err)
            return err;
        }
    };

    const agregarProcedimiento = async (dato) => {

        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addprocedimiento
            const resp = await addProcedimiento(dato);
            const procedimiento = resp.data.data;
            return procedimiento;
        }catch(err){
            console.log(err);
            if (err.response.data.code == 'DUPLICATEKEY') return err.response.data.code;
            else return null;
        }
        
    };

    const modificarProcedimiento = async (dato) => {
        try{
            const resp = await updateProcedimiento(dato);
            const procedimiento = resp.data.data;
            return procedimiento;
        }catch(err){
            console.log(err)
            return err.response.data;
        }
    }

    const eliminarProcedimiento = async (procedimiento) => {
        try{
            const resp = await deleteProcedimiento(procedimiento);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    const getProcedimientoByID = async(procID) =>{
        try {
            const resp = await getProcByID(procID);
            return resp;
        } catch (error) {
            console.log(error);
            
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarProcedimientoList();
    },[usuario])

    useEffect(()=>{
        if(server){
            server.on('procedimientosEdited', ({tenantId}) =>{
                console.log("Recibo el evento del Real Time Server procedimientosEdited");
                const verification = verificarTenant(tenantId)
                if(verification){
                    actualizarProcedimientoList();
                }
            })
            return () => {
                server.off('procedimientosEdited');
            }
        }
    },[server])

    return(
        <procedimientoContext.Provider
            value={{
                procedimientoList: state.procedimientoList,
                actualizarProcedimientoList:actualizarProcedimientoList,
                agregarProcedimiento,
                getProcedimientoByID,
                modificarProcedimiento,
                eliminarProcedimiento
            }}
        >
            {props.children}
        </procedimientoContext.Provider>
    )

}

export default ProcedimientoState;